import { SvgIcon } from '@material-ui/core'
import { React, withStyles } from '@api'

const styles = theme => ({
  large_icon: {
    width: 50,
    height: 50,
    color: '#6d6d6d',
    opacity: 0.5
  },
  medium_icon: {
    width: 32,
    height: 32,
    color: '#6d6d6d',
    opacity: 0.5,
    backgroundColor: '#f5f5f5'
  },
  small_icon: {
    width: 20,
    height: 20,
    color: '#6d6d6d',
    opacity: 0.5,
    backgroundColor: '#f5f5f5'
  }
})

const ImageComponent = ({classes, type}) => (
  <SvgIcon className={classes[`${type}_icon`]} viewBox={'0 0 50 50'}>
    <path
      d={'M5,5 L22.5,5 L22.5,0 L5,0 C2.25,0 0,2.25 0,5 L0,22.5 L5,22.5 L5,5 Z M20,27.5 L10,40 L40,40 L32.5,30 L27.425,36.775 L20,27.5 Z M37.5,16.25 C37.5,14.175 35.825,12.5 33.75,12.5 C31.675,12.5 30,14.175 30,16.25 C30,18.325 31.675,20 33.75,20 C35.825,20 37.5,18.325 37.5,16.25 Z M45,0 L27.5,0 L27.5,5 L45,5 L45,22.5 L50,22.5 L50,5 C50,2.25 47.75,0 45,0 Z M45,45 L27.5,45 L27.5,50 L45,50 C47.75,50 50,47.75 50,45 L50,27.5 L45,27.5 L45,45 Z M5,27.5 L0,27.5 L0,45 C0,47.75 2.25,50 5,50 L22.5,50 L22.5,45 L5,45 L5,27.5 Z'}/>
  </SvgIcon>
)

// @ts-ignore
export const ImagePlaceholder: any = withStyles(styles)(ImageComponent)



// WEBPACK FOOTER //
// ./src/shared/components/ui/icons/ImagePlaceholder.tsx